import { guidedOnboardingContent } from '@tableau/guided-onboarding';
import React, { useEffect, useRef, useState } from 'react';

import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { GuidedOnboardingStyles } from '../styles/GuidedOnboardingStyles';
import { GuidedOnboardingTestIds } from './GuidedOnboardingWelcomeBanner';

interface GuidedOnboardingWelcomeMessageProps {
    bannerWidth: number;
}

export function GuidedOnboardingWelcomeMessage({ bannerWidth }: GuidedOnboardingWelcomeMessageProps): JSX.Element {
    const userDisplayName = getSessionManagementServiceInstance().sessionUserInfo().displayName;
    const [finalHeaderContent, setFinalHeaderContent] = useState('');
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);

    const greetingWithUsername = guidedOnboardingContent.defaultGreeting.title({
        USER_DISPLAY_NAME: userDisplayName
    });
    const greetingWithoutUsername = guidedOnboardingContent.defaultGreeting.defaultTitle();
    const greetingBody = guidedOnboardingContent.defaultGreeting.content();

    // Check if lengthy message causes content to overflow the container's max-height.
    // If content height exceeds container height, hide the username to prevent overflow.
    useEffect(() => {
        if (bannerWidth) {
            setTimeout(() => {
                if (!containerRef.current || !contentRef.current) return;
                setFinalHeaderContent(greetingWithUsername);
                const containerHeight = containerRef.current.getBoundingClientRect().height;
                const contentHeight = contentRef.current.getBoundingClientRect().height;
                if (contentHeight > containerHeight) {
                    setFinalHeaderContent(greetingWithoutUsername);
                } else {
                    setFinalHeaderContent(greetingWithUsername);
                }
            });
        }
    }, [bannerWidth, greetingWithUsername, greetingWithoutUsername]);

    return (
        <div
            className={GuidedOnboardingStyles.bannerMessage}
            data-tb-test-id={GuidedOnboardingTestIds.bannerMessage}
            ref={containerRef}
        >
            <div ref={contentRef}>
                <h2 className={GuidedOnboardingStyles.bannerMessageHeader} data-tb-test-id={GuidedOnboardingTestIds.bannerGreeting}>
                    {finalHeaderContent}
                </h2>
                <p className={GuidedOnboardingStyles.bannerMessageSubheader} data-tb-test-id={GuidedOnboardingTestIds.bannerGreetingBody}>
                    {greetingBody}
                </p>
            </div>
        </div>
    );
}
